<template>
  <section class="container-fluid popular bg-light-2">
    <img
      :src="destination.detail_image"
      alt=""
      v-if="destination.detail_image"
    />
    <div class="bg-white container-small">
      <p
        class="popular__text text-gray"
        v-html="destination.description"
        id="popular_destinations_description"
      ></p>
      <div class="popular__nav">
        <h6 class="popular__subtitle d-flex justify-content-center">
          Навигация
        </h6>
        <a href="#popular_destinations_description" class="text-blue pb-3"
          >Описание</a
        >
        <a href="#popular_destinations_cruises" class="text-blue pb-3"
          >Круизы на теплоходах</a
        >
        <a
          href="#popular_destinations_cities"
          class="text-blue pb-3"
          v-if="destination.cities.length > 0"
          >Часто посещаемые города в круизе</a
        >
        <a
          href="#popular_destinations_destinations"
          class="text-blue pb-3"
          v-if="destination.destinations.length > 0"
          >Популярные направления</a
        >
      </div>
      <div class="swiper swiper__popular mt-6">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in destination.photos"
            :key="index"
          >
            <img :src="item.image" alt="" class="popular__img" />
          </div>
        </div>
        <button class="swiper-button-prev">
          <svg
            width="14"
            height="24"
            viewBox="0 0 14 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.93934 10.9393C1.35355 11.5251 1.35355 12.4749 1.93934 13.0607L11.4853 22.6066C12.0711 23.1924 13.0208 23.1924 13.6066 22.6066C14.1924 22.0208 14.1924 21.0711 13.6066 20.4853L5.12132 12L13.6066 3.51472C14.1924 2.92893 14.1924 1.97919 13.6066 1.3934C13.0208 0.807613 12.0711 0.807613 11.4853 1.3934L1.93934 10.9393ZM4 10.5L3 10.5L3 13.5L4 13.5L4 10.5Z"
              fill="#EDEDEE"
            />
          </svg>
        </button>
        <button class="swiper-button-next">
          <svg
            width="14"
            height="24"
            viewBox="0 0 14 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.93934 10.9393C1.35355 11.5251 1.35355 12.4749 1.93934 13.0607L11.4853 22.6066C12.0711 23.1924 13.0208 23.1924 13.6066 22.6066C14.1924 22.0208 14.1924 21.0711 13.6066 20.4853L5.12132 12L13.6066 3.51472C14.1924 2.92893 14.1924 1.97919 13.6066 1.3934C13.0208 0.807613 12.0711 0.807613 11.4853 1.3934L1.93934 10.9393ZM4 10.5L3 10.5L3 13.5L4 13.5L4 10.5Z"
              fill="#EDEDEE"
            />
          </svg>
        </button>
        <div
          style="position: relative !important; top: 0"
          class="swiper-pagination container-fluid"
        ></div>
      </div>
      <div v-if="items.length > 0">
        <h5 class="popular__title" id="popular_destinations_cruises">
          Круизы на теплоходах
        </h5>
        <CruiseListViewTable></CruiseListViewTable>

        <div class="d-tablet lk__reserve mt-9">
          <CruiseListSort></CruiseListSort>
          <div class="mt-5">
            <CruiseListViewCard
              v-for="item in items"
              :item="item"
              :key="item.id"
            />
          </div>
        </div>

        <div
            class="mt-3 d-flex align-items-center justify-content-center"
        >
          <button
              ref="load__block"
              class="card__link text-uppercase text-decoration-none btn btn-blue ml-2"
              @click="nextPage"
              v-if="options.last_page > options.page"
          >
            Загрузить еще
          </button>
        </div>

      </div>

      <h5
        class="popular__title"
        v-if="destination.cities.length > 0"
        id="popular_destinations_cities"
      >
        Часто посещаемые города в круизе
      </h5>

      <div
        class="d-flex flex-column flex-lg-row mb-2"
        v-for="(city, index) in destination.cities"
        :key="index"
      >
        <img
          class="col-lg-3 col-md-5 px-0 pr-sm-2 h-100"
          :src="city.image"
          alt=""
          v-if="city.image"
        />
        <div class="col-lg-9 col-md-7 px-0 pl-sm-2 mt-2">
          <h6 class="popular__subtitle">{{ city.name }}</h6>
          <p class="popular__text text-gray" v-html="city.description"></p>
          <a
            :href="city.link"
            class="text-blue small text-uppercase mt-1 fw-600"
            v-if="city.link"
            >Подробнее</a
          >
        </div>
        <hr class="w-100" />
      </div>

      <div class="popular__more" v-if="destination.destinations.length > 0">
        <h5 class="popular__title" id="popular_destinations_destinations">
          Популярные направления
        </h5>
        <div class="popular__block-wrap">
          <div
            class="popular__block-item pr-5 pb-5"
            v-for="(dest, index) in destination.destinations"
            :key="index"
          >
            <a
              :href="dest.detail_page_url"
              class="popular__block-link popular__item-solovetskie bg_cover"
              :style="'background: url(' + dest.image + ')'"
            >
              <span class="popular__block-bottom">
                {{ dest.name }}
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import CruiseListSort from "./CruiseListSort";
import CruiseListViewCard from "./CruiseListViewCard";
import CruiseListViewTable from "./CruiseListViewTable";
import Swiper from "swiper/swiper-bundle";

export default {
  name: "popular-destination-detail",
  components: {
    CruiseListSort,
    CruiseListViewCard,
    CruiseListViewTable,
  },
  computed: {
    ...mapGetters(["options", "items", "destination"]),
  },
  data() {
    return {
      mainSwiper: null,
      thumbsSwiper: null,
      isLoadingNextPage: false,
      allPagesLoaded: false,
    };
  },
  created: function () {
    if (this.destination.tags.length > 0) {
      this.getList();
    }
  },
  mounted() {
    this.loadSwiper();
  },
  methods: {
    loadSwiper: function () {
      new Swiper(document.querySelector(".swiper__popular"), {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: false,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        allowSlidePrev: true,
        allowSlideNext: true,
      });
    },
    getList: async function (addItems = false) {
      let generateParam = function (obj) {
        let str = [];
        for (var p in obj)
          if (Object.prototype.hasOwnProperty.call(obj, p)) {
            let item = obj[p];
            let parameter = "filter[" + p + "]";
            if (Array.isArray(item)) {
              if (item.length > 0) {
                parameter = "filter[" + p + "][]";
                item.forEach((element) => {
                  str.push(
                    encodeURIComponent(parameter) +
                      "=" +
                      encodeURIComponent(element)
                  );
                });
              }
            } else if (item) {
              str.push(
                encodeURIComponent(parameter) + "=" + encodeURIComponent(item)
              );
            }
          }
        return str.join('&');
      };
      let citiIds = [];
      this.destination.cities.forEach((item) => {
        citiIds.push(item.id);
      });
      await this.$store.dispatch(
          'getList',
          {
            filter: generateParam({
              tag: this.destination.tags,
              city_id: citiIds,
            }),
            addItems: addItems,
          }
      );
    },
    async nextPage() {
      const next_page = this.options.page + 1;
      if (next_page <= this.options.last_page && !this.allPagesLoaded) {
        this.isLoadingNextPage = true;
        await this.$store.commit('setPage', next_page);
        await this.getList(true);

        if (next_page === this.options.last_page) {
          this.allPagesLoaded = true;
        }
        this.isLoadingNextPage = false;
      }
    }
  },
};
</script>

<style lang="scss"></style>
